import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "../store/actions/auth";

export class Login extends Component {
  state = {
    email: "",
    password: "",
    error: null,
    loading: false
  };

  onChange = e => {
    this.setState({ [e.target.dataset.id]: e.target.value, error: null });
  };

  onSubmit = async e => {
    if (e) {
      e.preventDefault();
    }
    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ error: "Please enter both email and password." });
      return;
    }
    this.setState({ loading: true, error: null });
    try {
      await this.props.actions.login(email, password);
      // Full page load rather than a router push: ultils/helpers.js builds its
      // Authorization header from the cookie at module-evaluation time, so the
      // app has to be re-mounted for the new token to be picked up.
      window.location.href = "/Index";
    } catch (err) {
      this.setState({ loading: false, error: err.message });
    }
  };

  render() {
    const { email, password, error, loading } = this.state;
    return (
      <div>
        <div className="colm_costume colmResetPassword">
          <div className="logo">
            <img src={require("../images/logo.png")} alt="logo" />
          </div>
          <form className="login" onSubmit={this.onSubmit}>
            <div className="form-group">
              <input
                type="email"
                className="form-control"
                id="Email"
                data-id="email"
                placeholder="Email"
                autoComplete="username"
                onChange={this.onChange}
                value={email}
              />
            </div>
            <div className="form-group form-group-2">
              <input
                type="password"
                className="form-control"
                id="Password"
                data-id="password"
                placeholder="Password"
                autoComplete="current-password"
                onChange={this.onChange}
                value={password}
              />
            </div>
            {error && (
              <div id="LoginError" className="error" style={{ color: "#e0393e" }}>
                {error}
              </div>
            )}
            <div className="button">
              <button id="LoginSubmit" type="submit" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    ...state
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    actions: bindActionCreators(AuthActions, dispatch)
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
